import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DeleteIcon from '@mui/icons-material/Delete';

import AppHeader from './AppHeader';

export default function Home() {
  const theme = useTheme();

  const clickKey = () => {
    console.log('Go to challenge page');
  }

  const clickDelete = () => {
    console.log('Delete');
  }

  return (
    <React.Fragment>

      <Box
        sx={{
          height: '100%',
          width: '100%',
          backgroundColor: '#3B4E68',
          display: 'flex',
          flexDirection: 'column',
          paddingBottom: '20px',
        }}
      >

        <Box>
          <AppHeader />
        </Box>

        <Typography
          variant='body1'
          sx={{
            color: '#FFFFFF',
            fontSize: '24px',
            fontWeight: 'bold',
            textAlign: 'left',
            paddingLeft: '20px',
          }}
        >
          Registered Keys
        </Typography>


        <Box>


          <List
            sx={{
              color: '#FFFFFF',
            }}
          >
            <ListItem disablePadding>
              <ListItemButton
                onClick={clickKey}
              >
                <ListItemText primary="Google Mail" />
              </ListItemButton>
              <ListItemButton
                sx={{
                  justifyContent: 'flex-end',
                }}
                onClick={clickDelete}
              >
                <ListItemIcon
                  sx={{
                    color: '#FFFFFF',
                    justifyContent: 'flex-end',
                  }}
                >
                  <DeleteIcon />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                onClick={clickKey}
              >
                <ListItemText primary="Barclays Bank Plc" />
              </ListItemButton>
              <ListItemButton
                sx={{
                  justifyContent: 'flex-end',
                }}
                onClick={clickDelete}
              >
                <ListItemIcon
                  sx={{
                    color: '#FFFFFF',
                    justifyContent: 'flex-end',
                  }}
                >
                  <DeleteIcon />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </List>


        </Box>

      </Box>



    </React.Fragment>
  );
}